/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

function Menu({ menu, handleMenu, typeActive }) {
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Grid
			classes={{ root: classes.menuItem }}
			onClick={() => {
				handleMenu(menu?.code == typeActive ? "" : menu?.code);
			}}
		>
			<Grid
				classes={{ root: classes.btnMenu }}
				style={{
					background:
						typeActive === menu?.code
							? theme.palette.primary.main
							: theme.palette.grey[600],
					color:
						typeActive !== menu?.code
							? theme.palette.primary.contrastText
							: theme.palette.grey[600]
				}}
			>
				{menu?.name}
			</Grid>
		</Grid>
	);
}

const MenuProduct = memo(props => {
	const classes = useStyles();
	const { menus, handleSelectMenu, typeActive, setTypeActive } = props;

	const handleMenu = type => {
		setTypeActive(type);
		handleSelectMenu(type);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			{menus?.menu1?.length > 0 && (
				<Grid classes={{ root: classes.menu }}>
					<Grid style={{ display: "flex" }}>
						{menus?.menu1?.map(menu => (
							<Menu
								menu={menu}
								key={menu?.code}
								handleMenu={handleMenu}
								typeActive={typeActive}
							/>
						))}
					</Grid>
				</Grid>
			)}
			{menus?.menu2?.length > 0 && (
				<Grid classes={{ root: classes.menu }}>
					<Grid style={{ display: "flex" }}>
						{menus?.menu2?.map(menu => (
							<Menu
								menu={menu}
								key={menu?.code}
								handleMenu={handleMenu}
								typeActive={typeActive}
							/>
						))}
					</Grid>
				</Grid>
			)}
		</Grid>
	);
});

export default MenuProduct;
